export const externalLinkPath = "<path d=\"M6 13 H3 V10 M10 3 H13 V6 M13 3 L8.5 7.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
